export function createPerformanceStats(enabled) {
  return {
    enabled,
    frames: 0,
    droppedFrames: 0,
    maxFrameMs: 0,
    maxUpdateMs: 0,
    last: null,
    samples: [],
  };
}

export function getEntityCounts(game) {
  return {
    enemies: game.enemies.length,
    bullets: game.bullets.length,
    bossProjectiles: (game.bossProjectiles || []).length,
    hazards: (game.hazards || []).length,
    powerups: (game.powerups || []).length,
    explosions: (game.explosions || []).length,
    muzzleFlashes: (game.muzzleFlashes || []).length,
  };
}

export function recordPerformanceFrame(ref, frame, frameBudgetMs) {
  const stats = ref.current;

  if (!stats.enabled) {
    return;
  }

  stats.frames += 1;
  stats.last = frame;
  stats.maxFrameMs = Math.max(stats.maxFrameMs, frame.frameMs);
  stats.maxUpdateMs = Math.max(stats.maxUpdateMs, frame.updateMs);

  if (frame.frameMs > frameBudgetMs * 2) {
    stats.droppedFrames += 1;
  }

  stats.samples.push(frame);

  if (stats.samples.length > 180) {
    stats.samples.shift();
  }

  window.__arcadePerformance = stats;
}
